export default __webpack_public_path__ + "9da016b21221f03188fcd750fc51793c.svg";